/**
 * Mutual exclusion for map/list filter popovers (multi-select, HP/Dig., date range, …).
 * Opening one panel claims the slot and closes whichever panel held it before.
 */

export interface FilterOverlayPanel {
  closePanel(): void;
}

const SLOT_KEY = '__ttFilterOverlayPanel';

function overlaySlot(): { current: FilterOverlayPanel | null } {
  const root = globalThis as typeof globalThis & {
    [SLOT_KEY]?: { current: FilterOverlayPanel | null };
  };
  if (!root[SLOT_KEY]) root[SLOT_KEY] = { current: null };
  return root[SLOT_KEY];
}

/** Close any other open filter panel, then mark `panel` as the active one. */
export function claimFilterOverlay(panel: FilterOverlayPanel): void {
  const slot = overlaySlot();
  const previous = slot.current;
  if (previous && previous !== panel) {
    slot.current = panel;
    previous.closePanel();
  }
  slot.current = panel;
}

/** Clear the slot when `panel` closes (no-op if another panel already claimed). */
export function releaseFilterOverlay(panel: FilterOverlayPanel): void {
  const slot = overlaySlot();
  if (slot.current === panel) {
    slot.current = null;
  }
}

/** Test helper — reset coordinator state between specs. */
export function resetFilterOverlayCoordinatorForTests(): void {
  overlaySlot().current = null;
}
